export default {
  namespaced: true,
  state: {
    user: null,
    token: getToken(),
  },
  getters: {
    id (state, getters) {
      const { id } = getters.user || {}
      return id || 0
    },
    user (state) {
      return state.user || null
    },
    authed (state) {
      return !!state.token
    },
    isAdmin (state, getters) {
      return (getters.user || {}).role == 'ADMIN'
    },
    token (state) {
      return state.token
    },
    balance (state, getters) {
      if (!getters.user) {
        return 0
      }
      return getters.user.score_cache
    },
    unlockThreshold () {
      // For testing
      return 0
      return 60
    },
    typeUnlocks: (state, getters) => (type) => {
      const user = getters.user
      const checkLevels = [
        { level: '1', limit: false },
        { level: '1', limit: true },
        { level: '2', limit: false },
        { level: '2', limit: true },
      ]
      // For testing
      return checkLevels

      if (!user) {
        return checkLevels.slice(0, 1)
      }

      return user.unlocks
        .filter(unlock => unlock.type == type)
        .reduce((carry, unlock) => {
          if (unlock.score < getters.unlockThreshold) {
            return carry
          }
          // Finds matched level.
          const index = checkLevels.findIndex((level) => {
            return unlock.level == level.level
              && unlock.time_limited == level.limit
          })
          if (index == -1) {
            return carry
          }
          // Unlocks the next level.
          return [ ...carry, checkLevels[index + 1] ]
        }, checkLevels.slice(0, 1))
    },
  },
  mutations: {
    SET_TOKEN (state, token) {
      setToken(token)
      state.token = token
    },
    DEL_TOKEN (state) {
      delToken()
      state.token = null
    },
    SET_USER (state, user) {
      state.user = user
    },
  },
  actions: {
    saveToken ({ commit }, token) {
      return commit('SET_TOKEN', token)
    },
    async login ({ dispatch, commit }, payload) {
      const { login, password } = payload
      const { data } = await dispatch('http/post', {
        url: '/login',
        data: { login, password },
      }, { root: true })
      const { token } = data
      commit('SET_TOKEN', token)
    },
    async logout ({ commit }) {
      commit('DEL_TOKEN')
      commit('SET_USER', null)
    },
    async register ({ dispatch, commit }, payload) {
      const { login, password } = payload
      const { data } = await dispatch('http/post', {
        url: '/register',
        data: { login, password },
      }, { root: true })
      const { user } = data
      commit('SET_USER', user)
    },
    async getProfile ({ dispatch, commit }) {
      const { data } = await dispatch('http/get', {
        url: '/user/account',
      }, { root: true })
      commit('SET_USER', data)
    },
    async updateProfile ({ dispatch, commit }, payload) {
      const { data } = await dispatch('http/put', {
        url: '/user/account',
        data: payload,
      }, { root: true })
      commit('SET_USER', data)
    },
  },
}

function getToken () {
  return localStorage.getItem('token') || null
}

function setToken (token) {
  localStorage.setItem('token', token)
}

function delToken () {
  localStorage.removeItem('token')
}
